import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { StatusType } from "@trumpf/ux.ui-widgets/dist/types/components/status/status-types";
import { Default as PageIntro } from "../../../partial-templates/page-intro/page-intro.stories";
import { addI18nTranslations } from "../../../../utils";
import { renderPageTemplate } from "../../../../utils";

export default {
    title: "MyTrumpf/Page Templates/Company Admin/Overview",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const confirmed: StatusType = "ORDER_UNKNOWN";
const activated: StatusType = "ORDER_COMPLETE";

const userStatusLabels = {
    [confirmed]: "Bestätigt",
    [activated]: "Aktiviert",
};

const Template = (args) => {
    addI18nTranslations({
        namespace: "user-admin-overview",
        language: "de-DE",
        translations: {
            content: {
                email: {
                    column: "Email-Adresse",
                },
                status: {
                    column: "Status",
                    values: userStatusLabels,
                },
                detail: {
                    column: "Details",
                },
            },
        },
    });

    return html`
        <div
            class="ux-t-container-full">
                ${PageIntro({
                    headline: "Administration",
                })}
            <div class="ux-row">
                <ux-tab-container>
                    <ux-tab
                        name="Benutzerverwaltung"
                        tab-id="user-administration"
                        class="ux-u-mt-xxs ux-u-mb-s"
                    >
                        <div class="ux-row">
                            <div class=${`ux-col-10 ux-u-offset-1 ${args.isEmpty ? "ux-u-text-align--center ux-u-mb-ns" : ""}`}>
                                <p
                                    class="ux-text-normal ux-u-text-align--center ux-u-mb-m"
                                >
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                                    sed do eiusmod tempor incididunt ut labore et dolore magna
                                    aliqua.
                                </p>
                                <ux-button
                                    variant="primary"
                                    data-trigger-async-modal="open,user-invitation-modal"
                                    icon="plus"
                                    icon-placement="end"
                                >
                                    Neuen User einladen
                                </ux-button>
                                <ux-iws-async-modal
                                    name="user-invitation-modal"
                                    src="mock-data/company-admin/user-invitation-modal.html"
                                ></ux-iws-async-modal>
                            </div>
                        </div>
                        <ux-iws-stateful-overview
                            url=${args.isEmpty ? "./generated-mock-data/user-admin-overview-empty.json" : "./generated-mock-data/user-admin-overview.json"}
                            scope="user-admin-overview"
                            max-fixed-col-width="300"
                            switch="false"
                            show-count="false"
                            debug
                        ></ux-iws-stateful-overview>
                    </ux-tab>
                    <ux-tab
                        name="Rollenverwaltung"
                        tab-id="role-administration"
                        class="ux-u-mt-xxs ux-u-mb-s"
                    />
                    <div class="ux-row">
                        <div
                                class="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1"
                            >
                            <p
                                class="ux-text-normal ux-u-text-align--center ux-u-mb-m "
                            >
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                                do eiusmod tempor incididunt ut labore et dolore magna
                                aliqua.
                            </p>
                            </div>
                            <div
                                class="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1"
                            >
                                <ux-table full-width sortable>
                                    <table id="company-admin-role-administration">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <ux-table-sort
                                                        asc-name="name-asc"
                                                        desc-name="name-desc"
                                                        >Bezeichnung</ux-table-sort
                                                    >
                                                </th>
                                                <th>
                                                    Typ
                                                </th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span
                                                        class="ux-text-normal ux-text-normal--bold"
                                                        >Einkäufer</span
                                                    >
                                                </td>
                                                <td>
                                                    <span class="ux-u-disabled"
                                                        >Standardvorlage</span
                                                    >
                                                </td>
                                                <td>
                                                    <ux-button
                                                        type="button"
                                                        size="icon"
                                                        icon="chevron-right"
                                                        data-trigger-async-modal="open,role-details-modal"
                                                    >
                                                    </ux-button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span
                                                        class="ux-text-normal ux-text-normal--bold"
                                                        >Administrator</span
                                                    >
                                                </td>
                                                <td>
                                                    <span class="ux-u-disabled"
                                                        >Standardvorlage</span
                                                    >
                                                </td>
                                                <td>
                                                    <ux-button
                                                        type="button"
                                                        size="icon"
                                                        icon="chevron-right"
                                                        data-trigger-async-modal="open,role-details-modal"
                                                    >
                                                    </ux-button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span
                                                        class="ux-text-normal ux-text-normal--bold"
                                                        >Lorem ipsum</span
                                                    >
                                                </td>
                                                <td>
                                                    <span class="ux-u-disabled"
                                                        >Standardvorlage</span
                                                    >
                                                </td>
                                                <td>
                                                    <ux-button
                                                        type="button"
                                                        size="icon"
                                                        icon="chevron-right"
                                                        data-trigger-async-modal="open,role-details-modal"
                                                    >
                                                    </ux-button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Lorem ipsum</td>
                                                <td></td>
                                                <td>
                                                    <ux-button
                                                        type="button"
                                                        size="icon"
                                                        icon="chevron-right"
                                                        data-trigger-async-modal="open,role-details-modal"
                                                    >
                                                    </ux-button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Lorem ipsum</td>
                                                <td></td>
                                                <td>
                                                    <ux-button
                                                        type="button"
                                                        size="icon"
                                                        icon="chevron-right"
                                                        data-trigger-async-modal="open,role-details-modal"
                                                    >
                                                    </ux-button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Lorem ipsum</td>
                                                <td></td>
                                                <td>
                                                    <ux-button
                                                        type="button"
                                                        size="icon"
                                                        icon="chevron-right"
                                                        data-trigger-async-modal="open,role-details-modal"
                                                    >
                                                    </ux-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </ux-table>
                            </div>
                            <ux-iws-async-modal
                                name="role-details-modal"
                                src="mock-data/roles/role-details-modal.html"
                            ></ux-iws-async-modal>
                            </div>
                        </div>
                    </ux-tab>
                </ux-tab-container>
            </div>
        </div>

    `;
};

export const Default = () =>
    renderPageTemplate(() => Template({ isEmpty: false }));
export const Empty = () =>
    renderPageTemplate(() => Template({ isEmpty: true }));
